import Swiper from 'swiper/bundle';
import staticReviews from '../../data/google-reviews.json';

const star = (on) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 19" width="21" height="19"
       class="rv-star ${on ? 'rv-star--on' : ''}" aria-hidden="true">
    <path d="M9.17073 0.614785C9.51447 -0.201674 10.6852 -0.201673 11.029 0.614787L13.0577 5.43368C13.2027 5.77788 13.5304 6.01305 13.9065 6.04284L19.1725 6.45992C20.0647 6.53059 20.4265 7.63058 19.7467 8.20584L15.7346 11.6011C15.4481 11.8437 15.3229 12.2242 15.4104 12.5868L16.6362 17.6634C16.8439 18.5236 15.8967 19.2034 15.1329 18.7426L10.6244 16.022C10.3024 15.8277 9.89735 15.8277 9.57533 16.022L5.06684 18.7426C4.30296 19.2034 3.35581 18.5236 3.56349 17.6634L4.78928 12.5868C4.87683 12.2242 4.75168 11.8437 4.46511 11.6011L0.452916 8.20584C-0.226864 7.63058 0.134921 6.53059 1.02714 6.45992L6.29321 6.04284C6.66935 6.01305 6.99701 5.77788 7.14192 5.43368L9.17073 0.614785Z"/>
  </svg>`;

function reviewToSlide(r) {
  const rating = Math.round(Number(r.rating || 0));
  const ratingFormatted = Number(r.rating || 5).toFixed(1);
  const text = (r.text?.text || r.originalText?.text || '').replace(/"/g, '“').trim();
  const name = r.authorAttribution?.displayName || 'Google user';
  const photo = r.authorAttribution?.photoUri || '';

  return `
    <div class="col-12 col-md-4">
      <article class="rv-card h-100">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center gap-2">
            <img src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${rating}.svg" alt="${rating} stars" style="height:20px;">
          </div>
        </div>
        <p class="rv-quote text-normal">“${text}”</p>
        <div class="rv-person">
          ${photo
      ? `<img class="rv-avatar" src="${photo}" alt="${name}" loading="lazy">`
      : `<span class="rv-avatar rv-avatar--ph" aria-hidden="true"></span>`}
          <div>
            <p class="rv-name text-second fw-semibold mb-0">${name}</p>
            ${r.relativePublishTimeDescription
      ? `<p class="rv-meta text-second fw-normal mb-0">${r.relativePublishTimeDescription}</p>`
      : ``
    }
          </div>
        </div>
      </article>
    </div>
  `;
}

function reviewToMasonryItem(r) {
  const rating = Math.round(Number(r.rating || 0));
  const ratingFormatted = Number(r.rating || 5).toFixed(1);
  const text = (r.text?.text || r.originalText?.text || '').replace(/"/g, '“').trim();
  const name = r.authorAttribution?.displayName || 'Google user';
  const photo = r.authorAttribution?.photoUri || '';

  return `
    <div class="review-masonry-item">
      <article class="rv-card">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center gap-2">
            <img src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-${rating}.svg" alt="${rating} stars" style="height:20px;">
          </div>
        </div>
        <p class="rv-quote text-normal">“${text}”</p>
        <div class="rv-person">
          ${photo
      ? `<img class="rv-avatar" src="${photo}" alt="${name}" loading="lazy">`
      : `<span class="rv-avatar rv-avatar--ph" aria-hidden="true"></span>`}
          <div>
            <p class="rv-name text-second fw-semibold mb-0">${name}</p>
            ${r.relativePublishTimeDescription
      ? `<p class="rv-meta text-second fw-normal mb-0">${r.relativePublishTimeDescription}</p>`
      : ``
    }
          </div>
        </div>
      </article>
    </div>
  `;
}

const simpleStar = () =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"
       class="rv-star rv-star--simple" aria-hidden="true">
<path d="M7.41699 0.741211L8.9209 4.31348C9.1373 4.827 9.62351 5.17216 10.1748 5.21582L14.0703 5.52441L11.1094 8.03125C10.6851 8.39044 10.4958 8.95759 10.627 9.50098L11.5342 13.2559C11.533 13.2565 11.5322 13.2574 11.5312 13.2578C11.5299 13.2572 11.5279 13.2564 11.5254 13.2549L8.18359 11.2383C7.70942 10.9522 7.11381 10.9521 6.63965 11.2383L3.29883 13.2549C3.29539 13.257 3.29232 13.2573 3.29102 13.2578L3.28906 13.2568L4.19629 9.50098C4.32741 8.95763 4.13832 8.39052 3.71387 8.03125L0.751953 5.52441L4.64844 5.21582C5.19964 5.17217 5.68596 4.82703 5.90234 4.31348L7.40527 0.741211H7.41699Z" fill="black" stroke="black" stroke-width="1.48235"/>
  </svg>`;

function reviewToSimpleGridCard(r) {
  const rating = Math.round(Number(r.rating || 5));
  const safeRating = Math.max(0, Math.min(5, rating));
  const ratingFormatted = Number(r.rating || 5).toFixed(1);

  const text = (r.text?.text || r.originalText?.text || '')
    .replace(/"/g, '“')
    .trim();

  const name = r.authorAttribution?.displayName || 'Customer name';
  const starsHtml = Array.from({ length: safeRating }, () => simpleStar()).join('');

  return `
    <div class="col-12 col-lg-6">
      <article class="rv-card w-100 h-100">
        <div class="rv-rating d-flex align-items-center gap-2">
          <div class="rv-stars d-flex align-items-center">
            ${starsHtml}
          </div>

          <span class="rv-score">${ratingFormatted}</span>
        </div>

        <p class="rv-quote text-normal mb-0">“${text}”</p>

        <div class="rv-person rv-person--simple">
          <p class="rv-name text-tirty fw-semibold mb-0">- ${name}</p>
        </div>
      </article>
    </div>
  `;
}

function placeholderSimpleGridCards() {
  const fake = Array.from({ length: 4 }, () => ({
    rating: 5,
    text: {
      text:
        'Het bestellen is eenvoudig, de verzending ging prima volgens afspraak. De schermen zelf zijn zo opgezet en geven een prachtig beeld.'
    },
    authorAttribution: { displayName: 'Customer name' }
  }));

  return fake.map(reviewToSimpleGridCard).join('');
}

async function fetchReviews(apiKey, placeId) {
  const cacheKey = `google_reviews_v3_${placeId}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      // Cache for 24 hours
      if (Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000) {
        return parsed.data;
      }
    } catch (e) {
      // ignore
    }
  }

  const url = `https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}?languageCode=en`;
  const fieldMask = 'rating,userRatingCount,reviews';

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'X-Goog-Api-Key': apiKey,
      'X-Goog-FieldMask': fieldMask
    }
  });

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${body}`);
  }

  const json = await res.json();
  const reviews = Array.isArray(json.reviews) ? json.reviews : [];

  try {
    localStorage.setItem(cacheKey, JSON.stringify({
      timestamp: Date.now(),
      data: reviews
    }));
  } catch (e) {
    // ignore
  }

  return reviews;
}

function placeholderSlides() {
  const fake = Array.from({ length: 3 }, () => ({
    rating: 5,
    text: {
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique.'
    },
    authorAttribution: { displayName: 'Name Surname' },
    relativePublishTimeDescription: '—'
  }));
  return fake.map(reviewToSlide).join('');
}

const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

function toggleArrows(sw, next, prev) {
  if (!next || !prev) return;
  const single = sw.isBeginning && sw.isEnd;
  next.style.display = single ? 'none' : '';
  prev.style.display = single ? 'none' : '';
}

function dimEdgeSlides(sw) {
  sw.slides.forEach((s) => s.classList.remove('is-dimmed'));
  if (!isDesktop()) return;
  const toDim = Array.from(sw.slides).filter(
    (s) =>
      s.classList.contains('swiper-slide-visible') &&
      !s.classList.contains('swiper-slide-fully-visible')
  );
  toDim.forEach((s) => s.classList.add('is-dimmed'));
}

function mountSwiper(root) {
  const el = root.querySelector('.js-reviews-swiper');
  if (!el) return;

  if (el._swiper && typeof el._swiper.destroy === 'function') {
    el._swiper.destroy(true, true);
    el._swiper = null;
  }

  const next = root.querySelector('.reviews-next');
  const prev = root.querySelector('.reviews-prev');
  const pagination = root.querySelector('.reviews-pagination');

  el._swiper = new Swiper(el, {
    speed: 500,
    spaceBetween: 16,
    slidesPerView: 1,
    centeredSlides: false,
    watchSlidesProgress: true,
    pagination: pagination ? { el: pagination, clickable: true } : undefined,
    navigation:
      next && prev
        ? {
          nextEl: next,
          prevEl: prev
        }
        : undefined,
    breakpoints: {
      768: { slidesPerView: 2.1, spaceBetween: 16 },
      992: { slidesPerView: 3, spaceBetween: 32 }
    },
    on: {
      afterInit(sw) {
        sw.updateSlides();
        sw.updateSlidesProgress();

        toggleArrows(sw, next, prev);
        dimEdgeSlides(sw);

        const refresh = () => {
          sw.updateSlidesProgress();
          toggleArrows(sw, next, prev);
          dimEdgeSlides(sw);
        };

        sw.on('resize', refresh);
        sw.on('breakpoint', refresh);
        sw.on('slidesLengthChange', refresh);
        sw.on('slideChange', refresh);
        sw.on('progress', refresh);
        sw.on('setTranslate', refresh);
        sw.on('transitionEnd', refresh);
      }
    }
  });
}

function getMaxFromRoot(root) {
  const ds = root.querySelector('[data-max-reviews]')?.dataset.maxReviews;
  return Number(ds || 999);
}

function cloneSlidesToGrid(root) {
  const wrap = root.querySelector('.js-reviews-swiper .swiper-wrapper');
  const grid = root.querySelector('.js-reviews-grid');
  if (!wrap || !grid) return;

  const max = getMaxFromRoot(root);
  const cards = wrap.querySelectorAll('.swiper-slide .rv-card');
  if (!cards.length) return;

  grid.innerHTML = '';
  cards.forEach((card, idx) => {
    if (idx >= max) return;
    grid.appendChild(card.cloneNode(true));
  });
}

function observeWrapper(root) {
  const wrap = root.querySelector('.js-reviews-swiper .swiper-wrapper');
  const grid = root.querySelector('.js-reviews-grid');
  if (!wrap || !grid) return;
  if (grid._observing) return;
  grid._observing = true;

  const render = () => cloneSlidesToGrid(root);
  render();

  if ('MutationObserver' in window) {
    new MutationObserver(render).observe(wrap, { childList: true, subtree: true });
  }
}
/* ========================================================================== */

export async function initReviewsSwipers(scope = document) {
  scope.querySelectorAll('[data-reviews-root]').forEach(async (root) => {
    const key = root.dataset.apiKey?.trim();
    const place = root.dataset.placeId?.trim();
    const wrapper = root.querySelector('.reviews-list') || root.querySelector('.swiper-wrapper');

    const inDesign = typeof Shopify !== 'undefined' && Shopify.designMode;

    const hasDesktopGrid = !!root.querySelector('.js-reviews-grid');
    const isSimpleGrid = root.dataset.reviewsLayout === 'simple-grid';
    const renderReview = isSimpleGrid ? reviewToSimpleGridCard : reviewToSlide;
    const renderPlaceholder = isSimpleGrid ? placeholderSimpleGridCards : placeholderSlides;

    const manualCards = wrapper ? Array.from(wrapper.querySelectorAll('[data-manual-review]')) : [];

    if (!key || !place) {
      if (manualCards.length > 0) {
        mountSwiper(root);
        if (hasDesktopGrid) observeWrapper(root);
      } else if (inDesign && wrapper) {
        wrapper.innerHTML = renderPlaceholder();
        mountSwiper(root);
        if (hasDesktopGrid) observeWrapper(root);
      } else {
        mountSwiper(root);
        if (hasDesktopGrid) observeWrapper(root);
      }
      return;
    }

    try {
      const reviews = staticReviews || [];

      if (!reviews.length) {
        if (manualCards.length > 0) {
          mountSwiper(root);
          if (hasDesktopGrid) observeWrapper(root);
        } else if (inDesign && wrapper) {
          wrapper.innerHTML = renderPlaceholder();
          mountSwiper(root);
          if (hasDesktopGrid) observeWrapper(root);
        } else {
          mountSwiper(root);
          if (hasDesktopGrid) observeWrapper(root);
        }
        return;
      }

      const max = getMaxFromRoot(root);
      if (wrapper) {
        const isMasonry = wrapper.classList.contains('reviews-masonry');
        const apiReviews = reviews.slice(0, Math.max(0, max - manualCards.length));

        if (isMasonry) {
          const allItems = [
            ...manualCards.map(el => el.outerHTML),
            ...apiReviews.map(reviewToMasonryItem)
          ];
          const columnsHtml = ['', '', ''];
          allItems.forEach((itemHtml, idx) => {
            const colIdx = idx % 3;
            columnsHtml[colIdx] += itemHtml;
          });
          wrapper.innerHTML = columnsHtml
            .map(colContent => `<div class="reviews-masonry-col">${colContent}</div>`)
            .join('');
        } else {
          const apiHtml = apiReviews.map(renderReview).join('');
          const manualHtml = manualCards.map(el => el.outerHTML).join('');
          wrapper.innerHTML = manualHtml + apiHtml;
        }
      }
      mountSwiper(root);
      if (hasDesktopGrid) observeWrapper(root);
    } catch (err) {
      console.warn('[reviews-swiper] fetch error:', err);
      if (manualCards.length > 0) {
        mountSwiper(root);
        if (hasDesktopGrid) observeWrapper(root);
      } else if (inDesign && wrapper) {
        wrapper.innerHTML = renderPlaceholder();
        mountSwiper(root);
        if (hasDesktopGrid) observeWrapper(root);
      } else {
        mountSwiper(root);
        if (hasDesktopGrid) observeWrapper(root);
      }
    }
  });
}
